<template>
  <input :id="field.name"
         :name="field.name"
         :data-vv-as="field.description.replace(/\./g, '')"
         :type="field.type"
         class="form-control"
         v-validate="validators"
         :maxlength="field.maxSize"
         :minlength="field.minSize"
         :readonly="locked"
         :value="value"
         @input="input"
  />
</template>

<script>
import { computed } from "vue";

export default {
  props: {
    value: {
      type: [Number, String],
      required: false
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    }
  },

  emits: ['input'],

  setup(props, { emit }) {
    const input = (e) => {
      emit('input', parseFloat(e.target.value))
    }

    const validators = computed(() => {
      return {
        required: props.required && !props.field.hide,
        max: props.field.maxSize > 0 ? props.field.maxSize : false,
        min: props.field.minSize > 0 ? props.field.minSize : false,
        decimal: true
      }
    })

    return {
      validators,
      input,
    }
  }
}
</script>



// WEBPACK FOOTER //
// NumberRender.vue?023948c4